import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('/devices', { params })
  },
  getTotal (params) {
    return request.get('/devices/total', { params })
  },
  create (data) {
    return request.post('/devices', data)
  },
  update (id, data) {
    return request.put(`/devices/${id}`, data)
  },
  getOne (id) {
    return request.get(`/devices/${id}`)
  },
  remove (id) {
    return request.delete(`/devices/${id}`)
  },
  resetDeviceState(id) {
    return request.post(`/devices/${id}/full-reset`)
  },
  open(id, data = {}) {
    return request.post(`/devices/${id}/open`, data)
  },
  close(id, data = {}) {
    return request.post(`/devices/${id}/close`, data)
  },
  status(id) {
    return request.get(`/devices/${id}/status`)
  },
  camera(id) {
    return request.post(`/devices/${id}/camera`, { type: 'hls'})
  },
  p2pInit(id) {
    return request.post(`/devices/${id}/p2p-init`)
  },
  p2pStop(id, sessionId) {
    return request.post(`/devices/${id}/p2p-stop`, sessionId ? { sessionId } : {})
  },
}
